import { Coordinate } from 'ol/coordinate';
import { useMemo } from 'react';
import { useOpenLayersContext } from '../OpenLayersContext';

export function useCoordinateMemo(stationaryCoordinate: Coordinate | null) {
  const context = useOpenLayersContext();

  return useMemo(() => {
    if (!stationaryCoordinate) {
      return null;
    }
    const [xFloat, yFloat] =
      context.map.getPixelFromCoordinate(stationaryCoordinate);
    return {
      x: Math.round(xFloat),
      y: Math.round(yFloat),
    };
  }, [stationaryCoordinate, context.map]);
}
